import { createContext, useState } from "react";

export const LoaderContext = createContext({});
export const LoaderProvider = ({ children }) => {
  const [loaderClass, setLoaderClass] = useState("loader-class-hidden");
  const value = { loaderClass, setLoaderClass };
  return (
    <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>
  );
};
